import usePaymentMethodState from "Payments/AddPaymentMethod/paymentMethodState";

const useInitialACHData = () => {
  const { dispatch } = usePaymentMethodState();

  /**
   * @param {object} payload
   * @returns {void}
   */
  const setExistingACHData = (payload) => {
    dispatch({ type: "setExistingACHData", payload });
  };

  return { setExistingACHData };
};

const useAccountType = () => {
  const { ach, setACHState } = usePaymentMethodState();
  const accountType = ach?.accountType;

  /**
   * @param {"checking"|"savings"} type
   * @returns {void}
   */
  const setAccountType = (type) => {
    setACHState({ accountType: type });
  };

  return [accountType, setAccountType];
};

const useAccountHolderType = () => {
  const { ach, setACHState } = usePaymentMethodState();
  const accountHolderType = ach?.accountHolderType;

  /**
   * @param {"personal"|"business"} type
   * @returns {void}
   */
  const setAccountHolderType = (type) => {
    setACHState({ accountHolderType: type });
  };

  return [accountHolderType, setAccountHolderType];
};

const useAccountNumber = () => {
  const { ach, setACHState } = usePaymentMethodState();
  const accountNumber = ach?.accountNumber;

  /**
   * @param {string} acctNumber
   * @returns {void}
   */
  const setAccountNumber = (acctNumber) => {
    setACHState({ accountNumber: acctNumber });
  };

  return [accountNumber, setAccountNumber];
};

const useRoutingNumber = () => {
  const { ach, setACHState } = usePaymentMethodState();
  const routingNumber = ach?.routingNumber;

  /**
   * @param {string} routingNum
   * @returns {void}
   */
  const setRoutingNumber = (routingNum) => {
    setACHState({ routingNumber: routingNum });
  };

  return [routingNumber, setRoutingNumber];
};

const useACHIsEditing = () => {
  const { ach, setACHState } = usePaymentMethodState();
  const isEditing = ach?.isEditing;

  /**
   * @param {boolean} editing
   * @returns {void}
   */
  const setEditing = (editing) => {
    setACHState({ isEditing: editing });
  };

  return [isEditing, setEditing];
};

const useShouldRetokenize = () => {
  const { shouldRetokenize, setState, dispatch } = usePaymentMethodState();

  /**
   * @param {boolean} retokenize
   * @returns {void}
   */
  const setShouldRetokenize = (retokenize) => {
    setState({ shouldRetokenize: retokenize });
  };

  return [shouldRetokenize, setShouldRetokenize];
};

const useReplaceExistingCard = () => {
  const { replaceExistingCard, setState } = usePaymentMethodState();
  /**
   * @param {boolean} shouldReplace
   * @returns {void}
   */
  const setReplaceExistingCard = (shouldReplace) => {
    setState({ replaceExistingCard: shouldReplace });
  };

  return [replaceExistingCard, setReplaceExistingCard];
};

const usePaymentType = () => {
  const { state, setState } = usePaymentMethodState();
  const paymentType = state?.paymentType;

  /**
   * @param {string} type
   * @returns {void}
   */
  const setPaymentType = (type) => {
    setState({ paymentType: type });
  };

  return { paymentType, setPaymentType };
};

const useCardType = () => {
  const { state, setState } = usePaymentMethodState();
  const cardType = state?.cardType;

  /**
   * @param {string} type
   * @returns {void}
   */
  const setCardType = (type) => {
    setState({ cardType: type });
  };

  return { cardType, setCardType };
};

const useSubmitting = () => {
  const { state, setState } = usePaymentMethodState();
  const submitting = state?.submitting;

  /**
   * @param {boolean} bool
   * @returns {void}
   */
  const setSubmitting = (bool) => {
    setState({ submitting: bool });
  };

  return { submitting, setSubmitting };
};

const useName = () => {
  const { name, setState } = usePaymentMethodState();

  /**
   * @param {string} name
   * @returns {void}
   */
  const setName = (str) => {
    setState({ name: str });
  };

  return { name, setName };
};
const useExistingUserName = () => {
  const { existingUserName, setState } = usePaymentMethodState();

  /**
   * @param {string} existingUserName
   * @returns {void}
   */
  const setExistingUserName = (str) => {
    setState({ name: str });
  };

  return { existingUserName, setExistingUserName };
};

const useAccountHolderName = () => {
  const { accountHolderName } = usePaymentMethodState();

  return { accountHolderName };
};

export {
  useInitialACHData,
  useAccountType,
  useAccountHolderType,
  useAccountNumber,
  useRoutingNumber,
  useACHIsEditing,
  useShouldRetokenize,
  usePaymentType,
  useCardType,
  useSubmitting,
  useName,
  useReplaceExistingCard,
  useAccountHolderName,
  useExistingUserName,
};
